import React, { useEffect, useState,useContext } from 'react';
import { useLocation,useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CartContext } from '../../context/CartContext';
import VendorProductCardEditar from '../../components/VendorProductCardEditar';
import { useProductVendor } from '../../context/ProductVendorContext';

const EditarVendedorPage = () => {
  const { userId } = useParams();
  const location = useLocation();
  const { product } = location.state || {};
  console.log("valores en product:",product);
  // const [products, setProducts] = useState([]);
  // const [loading, setLoading] = useState(true);
    const { user } = useAuth();
  const { state, addToCart } = useContext(CartContext);
    const { fetchVendorProducts,products,loading,editVendorProduct } = useProductVendor();
 
  return (
    <div>
      <h2>Producto a editar</h2>
      <VendorProductCardEditar key={product.id} product={product} addToCart={addToCart} />
    </div>
  );
};

export default EditarVendedorPage;
